import EcommerceContext from './EcommerceProvider';
import { verificarEcommerce } from '../../api/apiCarros';
import { useContext, useEffect } from 'react';

const useVerificaEcommerce = (infoJson, viatura) => {
  const { dispatchEcommerce } = useContext(EcommerceContext);
  useEffect(() => {
    // cria array com todos os historicos da viatura

    const verificar = async () => {
      const info = await verificarEcommerce(viatura.CodViatura, infoJson);

      dispatchEcommerce({
        type: 'AddInfo',
        code: info?.cod_Eurotax ? info.cod_Eurotax : null,
        existe: info?.success ? info.success : false,
      });
    };
    viatura.ActivoEcommerce && viatura.Viatura === 'carros' && verificar();
  }, [viatura.CodViatura, viatura.ActivoEcommerce, infoJson, viatura.Viatura, dispatchEcommerce]);
};

export default useVerificaEcommerce;
